import React, { useState, useEffect } from "react";
// import { Modal, Button } from "react-bootstrap";
import {  FaTags, FaBars, FaCog, FaSignOutAlt, FaHome } from "react-icons/fa";
import EssFullWidthModal from "components/modelpopup/baseModal"
import { SidebarData } from "views/layout/sidebardata";

import { useNavigate, Link, useLocation } from "react-router-dom";

import {
    FaUser,FaUsers, FaChartBar, FaCalendarCheck, FaMoneyBill, FaWallet, FaBriefcase,
    FaCogs, FaFileAlt, FaBoxes, FaUserTimes, FaSitemap, FaTshirt, FaClipboardList
  } from "react-icons/fa";
  import { MdDashboard, MdHolidayVillage, MdOutlineSettings } from "react-icons/md";
  import { BsBuildings } from "react-icons/bs";
import { useAuth } from "context/userContext";
import { useSelector } from "react-redux";


const BottomNav = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showMenu, setShowMenu] = useState(false);
  const [permissions ,setPermissions] = useState([]);

  const {logout} = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogout = () =>{
    logout()
    navigate("/login")
  }
  
  const {
    user,
    userLoading
} = useSelector((state) => state.user);
useEffect(()=> {

  if(user?.role){
    console.log(user, "LLLLL")
    setPermissions(user?.role?.permissions.map(item=> item.code))
  }

  
},[user])



  const iconMap = {
    Dashboard: <MdDashboard />,
    "Employee Statistics": <FaChartBar />,
    Employees: <FaUser />,
    Holidays: <MdHolidayVillage />,
    "Leave List": <FaCalendarCheck />,
    "Leave View": <FaCalendarCheck />,
    "Leave Planner": <FaCalendarCheck />,
    Payroll: <FaMoneyBill />,
    Expenses: <FaWallet />,
    "Employee Salary": <FaMoneyBill />,
    "Payroll Items": <FaMoneyBill />,
    "Manage Jobs": <FaBriefcase />,
    "Manage Resumes": <FaBriefcase />,
    "Employee referrals": <FaUsers />,
    "Company Directory": <BsBuildings />,
    Documents: <FaFileAlt />,
    Assets: <FaBoxes />,
    Resignation: <FaUserTimes />,
    "Designations": <FaSitemap />,
    "Departments": <FaSitemap />,
    "Grades": <FaSitemap />,
    "Roles & Permissions": <FaCogs />,
    "Request Approver": <FaCogs />,
    "Uniforms": <FaTshirt />,
    "Assign Uniform": <FaTshirt />,
    "List Allocations": <FaTshirt />,
    "Uniform Stock": <FaTshirt />,
  };

  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

 const onClose = () => {
    setShowMenu(!showMenu)
  }
  if (!isMobile) return null; // Render only for mobile view
  const handleNavigation = (route) => {
    if(route.includes("https")){
      window.open(route, "_blank")
    }else{
      navigate(route);
    }
    onClose(); // Close modal on click
  };
  const handleNavButton = (route) => {
    navigate(route)
  }

  const showSubMenu = (menus) => {
    let show = false

    menus.forEach(menu => {
      if(permissions?.includes(menu?.code)){
        show = true
      }
    })
    return show
  }
  return (
    <>
      {/* Bottom Navigation Bar */}
      <div className="bottom-nav d-flex justify-content-around align-items-center">
      <div className="footer-nav-item" onClick={()=>handleNavButton(`/employee-dashboard`)}   >
          <FaHome size={24}  className={location.pathname == `/employee-dashboard` && "text-danger"} />
          <span  className={location.pathname == `/employee-dashboard` && "text-danger"} >Home</span>
        </div>
        <div className="footer-nav-item"  onClick={()=>handleNavButton(`/employees/${user?.id}`)}>
          <FaUser size={24}  className={location.pathname == `/employees/${user?.id}` && "text-danger"} />
          <span  className={location.pathname == `/employees/${user?.id}` && "text-danger"}>Profile</span>
        </div>
        {
          user?.role?.access_scope !== "store_manager"&&(
<div className="footer-nav-item"  onClick={()=>window.open("https://discount.nandosess.ae", "_blank")} >
          <FaTags size={24} />
          <span>Discount</span>
        </div>
          )
        }
        
        {/* <div className="footer-nav-item">
          <FaUsers size={24} />
          <span>Employees</span>
        </div> */}
        <div className="footer-nav-item" onClick={onClose}>
          <FaBars size={24} />
          <span>Menu</span>
        </div>
      </div>

      {/* Modal for Menu */}
      <EssFullWidthModal 
        mask={false}
        title={"Menus"}
        // style={{ top: 100 }}
        open={showMenu}
        width={"40%"}
        footer={[]}     
        onCancel={onClose}
          className="full-width-modal"
      >
   
   
        <div className="modal-content">
        <div className="col-12">
          <div className="row" >
        {SidebarData.map((item, index) => {
           if(!item.hasSubRoute && item?.code && permissions?.includes(item?.code)){
            return (
              <React.Fragment key={index}>
              
              <div className=" col-6  m-0 p-0" onClick={() => handleNavigation(item.route)}>
                <div className="menu-item m-2" style={{height:120}}> 
                {iconMap[item.menuValue] || <FaClipboardList />}
                <span>{item.menuValue}</span>
                </div>
               
              </div>
              </React.Fragment>
            )
          }
          else if(item.hasSubRoute){
            return (
              <>
              
              {
                item.subMenus && item.subMenus.length > 0 && showSubMenu(item.subMenus) && (
              <div className="col-12 my-2 fw-bolder" >
                {item?.menuValue}
              </div>
                )
              }
              
              {
                item.subMenus.map((subItem, subIndex) => {
                  if(subItem?.code && permissions?.includes(subItem?.code)){
                    return(
                      <div key={subIndex} className="col-6  m-0 p-0" onClick={() => handleNavigation(subItem.route)}>
                        <div className="menu-item m-2" style={{height:120}}> 
                      {iconMap[subItem.menuValue] || <FaClipboardList />}
                      <span>{subItem.menuValue}</span>
                      </div>
                    </div>
                    )
                  }
                  
                })
              }
              {
                showSubMenu(item.subMenus) && (
                  <div className="col-12 my-2 fw-bolder " >
              <hr/>
                </div>
                )
              }
              
              </>
            )

          }
            
          
            
           
            
          
        })}
          <div className="col-6 m-0 p-0" onClick={handleLogout}>
          <div className="menu-item m-2" onClick={handleLogout}  style={{height:120}}>
              <FaSignOutAlt size={30} />
              <span>Logout</span>
              </div>
            </div>
        </div>
      
      </div>
        </div>
      </EssFullWidthModal>
    </>
  );
};

export default BottomNav;
